import { render, staticRenderFns } from "./CsdSummaryCard.vue?vue&type=template&id=5cbd3e27&scoped=true&"
import script from "./CsdSummaryCard.vue?vue&type=script&lang=js&"
export * from "./CsdSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd3e27",
  null
  
)

export default component.exports